import { render, staticRenderFns } from "./RbModalForm.vue?vue&type=template&id=5044c13f"
import script from "./RbModalForm.vue?vue&type=script&lang=js"
export * from "./RbModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports